/**
 * Created by griga on 7/11/16.
 */


import {Routes, RouterModule} from '@angular/router';
import {MainLayoutComponent} from "./shared/layout/app-layouts/main-layout.component";
import {AuthLayoutComponent} from "./shared/layout/app-layouts/auth-layout.component";
import {ModuleWithProviders} from "@angular/core";
import {CanAccessGuard} from 'app/core/guards/can-access.guard';

export const routes: Routes = [
    {
        path: '',
        component: MainLayoutComponent,
        canActivate: [CanAccessGuard],
        data: {pageTitle: 'Home'},
        children: [
            {
                path: '',
                redirectTo: 'dashboard',
                pathMatch: 'full'
            },

            {
                path: 'dashboard',
                loadChildren: 'app/+dashboard/dashboard.module#DashboardModule',
                data: {pageTitle: 'Dashboard'}
            },

            {
                path: 'configsteps',
                loadChildren: 'app/+configsteps/configsteps.module#ConfigStepsModule',
                data: {pageTitle: 'Config', acl: ["CONFIGSTEPS*"]}
            },

            {
                path: 'admin',
                loadChildren: 'app/+admin/admin.module#AdminModule',
                data: {pageTitle: 'Config admin', acl: ["ADMINCONFIG*"]}
            },

            {
                path: 'reservations',
                loadChildren: 'app/+reservations/reservations.module#ReservationsModule',
                data: {pageTitle: 'Reservations', acl: ["RESERVATIONS*"]}
            },

            {
                path: 'inventory',
                loadChildren: 'app/+inventory/inventory.module#InventoryModule',
                data: {pageTitle: 'Inventory', acl: ["INVENTORY*"]}
            },

            {
                path: 'trends',
                loadChildren: 'app/+trends/trends.module#TrendsModule',
                data: {pageTitle: 'Trends', acl: ["TRENDS*"]}
            },

            {
                path: 'usersandclients',
                loadChildren: 'app/+usersandclients/usersandclients.module#UsersAndClientsModule',
                data: {pageTitle: 'Users and clients', acl: ["USERS*", "CLIENTS*"]}
            },

            {
                path: 'miscellaneous',
                loadChildren: 'app/+miscellaneous/miscellaneous.module#MiscellaneousModule',
                data: {pageTitle: 'Miscellaneous'}
            }
        ]
    },

    {path: 'auth', component: AuthLayoutComponent, loadChildren: 'app/+auth/auth.module#AuthModule'},

    {path: '**', redirectTo: 'miscellaneous/error404'}

];

export const routing: ModuleWithProviders = RouterModule.forRoot(routes, {useHash: true});



// WEBPACK FOOTER //
// ./src/app/app.routing.ts